import {
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  Navigate,
  useLocation,
} from "react-router-dom";
import { useEffect, useState } from "react";
import { ToastProvider, useToast } from "./components/ToastProvider";
import { setToastFn } from "./toastService";
import Login from "./pages/Login";
import Otp from "./pages/Otp";
import Dashboard from "./pages/Dashboard";
import Course from "./pages/Course";
import "./styles/Loading.css";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check authentication status
    const authStatus = localStorage.getItem("isAuthenticated") === "true";
    setIsAuthenticated(authStatus);
  }, []);

  const AuthGuard = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      const urlParams = new URLSearchParams(location.search);
      const token = urlParams.get("token");

      if (token) {
        // ✅ Save token
        localStorage.setItem("accessToken", token);
        localStorage.setItem("isAuthenticated", "true");
        localStorage.removeItem("username")

        // ✅ Save dummy refreshToken
        localStorage.setItem("refreshToken", "dummy-refresh-token");

        // Clean up URL
        urlParams.delete("token");
        const newUrl =
          location.pathname +
          (urlParams.toString() ? `?${urlParams.toString()}` : "");
        navigate(newUrl, { replace: true });

        setLoading(false);
        return;
      }

      const authStatus = localStorage.getItem("isAuthenticated") === "true";
      if (!authStatus) {
        const currentPath = window.location.pathname + window.location.search;
        if (
          currentPath !== "/" &&
          currentPath !== "/otp" &&
          currentPath !== "/dashboard"
        ) {
          sessionStorage.setItem("redirectPath", currentPath);
        }
        navigate("/");
      } else {
        setLoading(false);
      }
    }, [navigate, location]);

    if (loading) {
      return (
        <div className="loading-screen">
          <div className="loading-content">
            <div className="spinner"></div>
            <p>Loading</p>
          </div>
        </div>
      );
    }

    return children;
  };

  return (
    <ToastProvider>
      <Initializer />
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/otp" element={<Otp />} />
          <Route
            path="/dashboard"
            element={
              <AuthGuard>
                <Dashboard />
              </AuthGuard>
            }
          />
          <Route
            path="/courses/:id"
            element={
              <AuthGuard>
                <Course />
              </AuthGuard>
            }
          />
          {/* Catch-all route for unmatched paths */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </ToastProvider>
  );
}

function Initializer() {
  const { showToast } = useToast();
  setToastFn(showToast); // connect global function
  return null;
}

export default App;
